import '../css/main.css';
import {socialLinks} from "./about/SocialLinks"
import {Link} from "react-router-dom";
import React, {useEffect, useRef, useState} from 'react';
import Video from '../images/logo_video.webm';
import Gazprom from "../images/lizing/gazprom.webp";
import Tatneft from "../images/lizing/tatneft.webp";
import Lukoil from "../images/lizing/lukoil.webp";
import Rosneft from "../images/lizing/rosneft.webp";
import Taneco from "../images/lizing/taneco.webp";
import Sibur from "../images/lizing/sibur.webp";
import Nornikel from "../images/lizing/nornikel.webp";
import Novatek from "../images/lizing/novatek.webp";

import mehService from "../images/service/meh.webp"
import ufv from "../images/production/machines/milling/uvf1/6.webp";
import foundry from "../images/service/foundry/foundry.webp";

import sespelImg1 from "../images/about/company/image_sespel_6.webp";
import sespelImg2 from "../images/about/company/image_sespel_1.webp";
import sespelImg3 from "../images/about/company/image_sespel_10.webp";

import {findElementByLink} from "./utils/siteStructure";
import siteStructure from "./siteStructure.json";

import {CompanyMainIndicatorsText} from "./about/Company";
import SeoHelmet from "./utils/seo";
import {useNews} from "./news/NewsContext";
import {EyeOutlined} from "@ant-design/icons";
import {useTheme} from "./header/Header";

// Динамическая загрузка изображений
const images = require.context('../images/', true, /\.(webp|webm)$/);
const getImage = (path) => {

    try {
        return images(`./${path}`);
    } catch (error) {
        console.log(`Изображение ${path} не найдено`)
        return ""
    }
}


export default function Main() {

    const {newsData} = useNews();
    const [playVideo, setPlayVideo] = useState(false);
    const [textVisible, setTextVisible] = useState(false); // Состояние для текста
    const videoRef = useRef(null);
    const thisYear = new Date().getFullYear()
    const {theme} = useTheme()

    const services = [
        {
            img: mehService, text: "Механическая обработка",
            hiddenText: `Воспользуйтесь высокотехнологичным оборудованием, предназначенным для обработки крупногабаритных
                деталей с высочайшей точностью. Токарная и фрезерная обработка  различных форм и размеров.`,
            nav: "/services/mechanical_processing"
        },
        {
            img: ufv, text: "Станкостроение", hiddenText: `Использование современных программных комплексов для 3D-моделирования и
          инженерных расчётов обеспечивает высокую точность и детализацию даже самых сложных проектов.`, nav: ""
        },
        {
            img: foundry, text: "Литейное производство",
            hiddenText: `Литейным участком изготавливается отливка из следующих сплавов: углеродистая 
            и высоколегированная стали, серый и высокопрочный чугун, легкие цветные сплавы (АК12, АМг5).`,
            nav: "/services/foundry"
        }
    ]

    const companyImages = [sespelImg1, sespelImg2, sespelImg3]

    useEffect(() => {

        // Показываем текст сразу после загрузки
        setTextVisible(true);

        const timerScroll = setTimeout(() => {
            window.scrollTo(0, 0);
        }, 1)

        // Устанавливаем таймер для видео
        const timer = setTimeout(() => {
            setPlayVideo(true);
            if (videoRef.current) {
                videoRef.current.play().catch((error) => {
                    console.error('Автовоспроизведение заблокировано:', error);
                });
            }
        }, 3000);

        return () => {
            // console.log("punch2")
            clearTimeout(timerScroll);
            clearTimeout(timer);
        }

        // Очищаем таймер
    }, []);

    return (
        <div className="main-container">
            <SeoHelmet title={"Сеспель | Официальный сайт"} description={"Чебоксарское предприятие «Сеспель» - услуги литейного производства, обслуживание контейнер-цистерн, продажа специализированной техники: станки СТП, мостовые краны, арматура, контейнеры-цистерны"} keywords={"Сеспель, Чебоксары, станкостроение, сварка трением с перемешиванием, СТП, фрезерные станки, мостовые краны, арматура, клапаны, краны шаровые, фильтры, осевые агрегаты, контейнеры-цистерны, химические грузы, сжиженные газы, криогенные контейнеры, силосы, нефтехранилища, механическая обработка, литейное производство, диагностика криогенных контейнеров"} canonicalUrl={"https://sespel.su"}/>
            <div className={`mainBackground`}> </div>

            <div className="media-container">
                <video disablePictureInPicture
                       muted
                       playsInline
                       loop
                       ref={videoRef}
                       className={`media-video ${playVideo ? 'play' : ''}`}
                       src={Video}
                />

                <div className={"mainVideoTextWrapper"}>
                    <span className={`fade-in-text ${textVisible ? 'visible' : ''}`}>
                        Технологии, которые работают на вас.
                    </span>
                    <span className={`fadeText ${textVisible ? 'visible' : ''}`}>
                        Ваш партнер в мире машиностроения.
                    </span>
                </div>
            </div>

            <div className={`mainContent ${theme}`}>
                <div className={"mainShortContent"}>
                    <MainProduction url={"production"}/>

                    <div className={"mainPageServices"}>
                        <h1>Услуги</h1>
                        <div>
                            {services.map(service => {
                                return (
                                    <Link to={`${service.nav}`} key={service.text}>
                                        <img src={service.img} alt="no-img"/>
                                        <div><p>{service.text}</p></div>
                                        <p>{service.hiddenText}</p>
                                    </Link>
                                )
                            })
                            }
                        </div>
                    </div>

                    <div>
                        <h1>Основные показатели</h1>
                        <CompanyMainIndicatorsContent/>
                    </div>

                    <div className={"mainPageCompany"}>
                        <div>
                            <h1>О Компании</h1>
                            <p>Чебоксарское предприятие «Сеспель» — самый современный завод</p>

                            <p>
                                Нашей первоочередной задачей является безусловное ориентирование на потребности
                                клиентов.
                                Для этого мы адаптируем свои решения к индивидуальным запросам и требованиям к
                                производству.
                                Номенклатурный ряд нашей техники составляет более 630 моделей
                                из низколегированной, нержавеющей стали и алюминиевого сплава.

                                Наш многолетний опыт работы в качестве одного из ведущих Российских поставщиков
                                специализированной техники
                                делает нас компетентным партнером в области решений по перевозке сыпучих и жидких
                                грузов.
                            </p>
                        </div>

                        <div className={"mainPageCompanyGallery"}>
                            {companyImages.map((img, i) =>
                                <img key={`companyImg${i}`} src={img} alt="no-img"/>)}
                        </div>
                    </div>

                    <div className={"lizingFinancePartners"}>
                        <div>
                            <h1>Работаем с крупнейшими игроками нефтегазовой отрасли</h1>
                            <p>
                                Компания зарекомендовала себя как надежный партнер,
                                предлагающий высококачественные решения для своих клиентов.
                                Благодаря современным технологиям, профессиональной команде
                                и индивидуальному подходу к каждому заказчику
                            </p>
                        </div>
                        <div>
                            <img src={Nornikel} alt="no-img"/>
                            <img src={Gazprom} alt="no-img"/>
                            <img src={Tatneft} alt="no-img"/>
                            <img src={Novatek} alt="no-img"/>
                            <img src={Lukoil} alt="no-img"/>
                            <img src={Rosneft} alt="no-img"/>
                            <img src={Taneco} alt="no-img"/>
                            <img src={Sibur} alt="no-img"/>
                        </div>
                    </div>

                    <MainNews news={newsData.slice(0, 10)}/>
                </div>
            </div>
            <div className={`mainFooter ${theme}`}>
                <div>
                    <span>г. Чебоксары, ул. Ленинградская, 36 (<Link to={"/about/contacts"}>на карте</Link>)</span>
                    <span>Тел./факс: +7(800) 505-06-34 (многоканальный)</span>
                    <span>Тел./факс: +7(835) 222-57-22 (многоканальный)</span>
                    <span>zaosespel@yandex.ru</span>
                </div>
                <div>
                    <span>© 2013-{thisYear} ЗАО «Чебоксарское предприятие «Сеспель»</span>
                    <div className={"mainFooterSocial"}>
                        {socialLinks.map(link =>
                            <Link key={link.name} to={link.url}>
                                {link.icon}
                            </Link>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

function CompanyMainIndicatorsContent() {

    function createIndicatorsContent(bigText, smallText) {
        return {bigText, smallText}
    }

    const content = {
        years: createIndicatorsContent(`${new Date().getFullYear() - 1992}`, "года на рынке"),
        area: createIndicatorsContent("30 000", "кв.м. производственных площадей"),
        shop: createIndicatorsContent("7", "цехов"),
        research: createIndicatorsContent("3", "исследовательских центра"),
        machine: createIndicatorsContent(">20", "произведенных уникальных станочных комплексов"),
        welding: createIndicatorsContent(">300", "км/год сварки"),
        molding: createIndicatorsContent(">1 000", "т/год промышленного литья"),
    }
    return (
        <div className={"company-main-indicators"}>
            <div>
                <CompanyMainIndicatorsText {...content.years}/>
                <CompanyMainIndicatorsText {...content.area}/>
                <CompanyMainIndicatorsText {...content.shop}/>
                <CompanyMainIndicatorsText {...content.research}/>
            </div>
            <div>
                <CompanyMainIndicatorsText {...content.machine}/>
                <CompanyMainIndicatorsText {...content.welding}/>
                <CompanyMainIndicatorsText {...content.molding}/>
            </div>
        </div>
    )
}

export function nextSlide(setCurrentIndex, length, count) {
    setCurrentIndex((prevIndex) => {
        if (prevIndex + count > length || length - (prevIndex + count) === 0) {
            return 0
        }

        if (length - (prevIndex + count) < count) {
            const step = prevIndex + count * 2 - length;
            return (prevIndex + count) % length - step;
        }
        return (prevIndex + count) % length;
    })
}

export function prevSlide(setCurrentIndex, length, count) {
    setCurrentIndex((prevIndex) => {
        if (length === prevIndex + count && prevIndex % count) {
            return prevIndex - prevIndex % count
        }
        return (prevIndex - count < 0 ? length - count : prevIndex - count)
    });
}

function MainProduction({url, count = 3}) {

    const data = findElementByLink(siteStructure, url)

    const links = data ? data.links : {}

    const [currentIndex, setCurrentIndex] = useState(0);

    const length = Object.keys(links) ? Object.keys(links).length : 0

    const {theme} = useTheme()

    return (
        <>
            {
                length === 0 ? null :
                    <div className={"mainContentProduction"}>
                        <h1>Продукция</h1>
                        {
                            length <= count? null :
                                <>
                                    <button className="slider-button left" onClick={() => {
                                        prevSlide(setCurrentIndex, length, count)
                                    }}>
                                        &#10094;
                                    </button>

                                    <button className="slider-button right" onClick={() => {
                                        nextSlide(setCurrentIndex, length, count)
                                    }}>
                                        &#10095;
                                    </button>
                                </>
                        }

                        <div className="slider-container">

                            <div
                                className="slider-content"
                                style={{
                                    transform: `translate3d(-${currentIndex * (100 / count)}%, 0, 0)`,
                                }}
                            >
                                {Object.keys(links).map(key => (
                                    <Link
                                        key={key}
                                        to={`${data.url}/${key}`}
                                        className={`slider-item ${theme}`}
                                        style={{flex: `0 0 ${100 / count}%`}}
                                    >
                                        <img src={getImage(links[key].image)} alt="no-img"/>
                                        <p>{links[key].title}</p>
                                    </Link>
                                ))}
                            </div>
                        </div>
                    </div>
            }
        </>
    );
}

function MainNews({news, count = 3}) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const length = news.length
    const {theme} = useTheme()

    return (
        <div className={"mainContentNews"}>
            <h1>Последние новости</h1>
            <button className="slider-button left" onClick={() => {
                prevSlide(setCurrentIndex, length, count)
            }}>
                &#10094;
            </button>
            <button className="slider-button right" onClick={() => {
                nextSlide(setCurrentIndex, length, count)
            }}>
                &#10095;
            </button>
            <div className="slider-container">
                <div
                    className="slider-content"
                    style={{
                        transform: `translate3d(-${currentIndex * (100 / count)}%, 0, 0)`,
                    }}
                >
                    {news.map((n, index) => (
                        <div className={"mainLinkNewsWrapper"} key={index} style={{flex: `0 0 ${100 / count}%`}}>
                            <Link
                                to={n.url}
                                className="slider-item"
                            >
                                <img src={n.image} alt="no-img"/>
                            </Link>
                            <div className={`news-preview-container ${theme}`}>
                                <p>{n.date}</p>
                                <div className="news-views">
                                    <span>{n.views || 0}</span>
                                    <EyeOutlined />
                                </div>
                            </div>
                            <p>{n.title}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}
